<template>
  <kd-popup class="campus-academy-create-class-popup" position="center" :visible.sync="show" hideTitle>
    <div class="title">创建学院</div>
    <kd-input v-model="clazzName" maxlength="20" placeholder="请输入班级名称"></kd-input>
    <div class="btns">
      <kd-button type="secondry" @click="$emit('update:visible', false)">取消</kd-button>
      <kd-button type="primary" @click="handleSubmit">确定</kd-button>
    </div>
  </kd-popup>
</template>

<script lang="ts">
import { BaseComponent, Component, Prop, PropSync } from 'kuaidong-component'
import { KdPopup, KdInput, KdButton } from 'kuaidong-ui'
import { addAcademy } from '../api'

@Component({
  components: {
    KdInput,
    KdPopup,
    KdButton,
  },
})
export default class CreateClassPopup extends BaseComponent {
  @PropSync('visible', { type: Boolean, default: false })
  show!: boolean
  @Prop({ type: String, default: '' })
  name!: string
  clazzName = ''
  mounted() {
    this.clazzName = this.name
  }
  async handleSubmit() {
    try {
      this.$emit('submit', this.clazzName)
    } catch (e) {
      this.toast(e.text || '创建失败')
    }
  }
}
</script>

<style lang="less">
.kd-popup.campus-academy-create-class-popup {
  > .kd-popup__main {
    border-radius: 16px;
    > .kd-popup__content {
      position: relative;
      > .title {
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #000;
        margin-bottom: 12px;
      }
      > .btns {
        width: 260px;
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        > .kd-button {
          width: 118px;
          border-radius: 22px;
        }
      }
    }
  }
}
</style>
